/**
 * Shopify Pre-order Warning Popup
 * Shows a warning when the cart contains at least one product with the "pre order" tag
 */
function checkForMixedCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;

    const productCheckPromises = cart.items.map(item => {
        const productId = item.handle ? item.handle.split('?')[0] :
            (item.url ? item.url.split('?')[0].split('/').pop() : null);

        if (!productId) return Promise.resolve(null);

        return fetch(`/products/${productId}.js`)
            .then(res => res.json())
            .then(product => {
                if (product.tags) {
                    const isPreOrder = product.tags.some(tag => tag.toLowerCase() === 'pre-order');
                    return {
                        id: product.id,
                        isPreOrder: isPreOrder
                    };
                }
                return { id: product.id, isPreOrder: false };
            })
            .catch(err => {
                console.error('Error checking product tags:', err);
                return null;
            });
    });

    // Check if we have both pre-order AND regular products
    return Promise.all(productCheckPromises).then(results => {
        const validResults = results.filter(result => result !== null);
        const hasPreOrderItem = validResults.some(item => item.isPreOrder);
        const hasRegularItem = validResults.some(item => !item.isPreOrder);

        // Return true only if we have both types of products
        return hasPreOrderItem && hasRegularItem;
    });
}

function showPreorderWarning() {
    const warningPopup = document.getElementById('pn-mixed-cart-warning');
    if (warningPopup) {
        warningPopup.style.display = 'block';

        const closeBtn = document.getElementById('pn-modal-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                warningPopup.style.display = 'none';
            });
        }

        warningPopup.addEventListener('click', function(e) {
            if (e.target === warningPopup) {
                warningPopup.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const style = document.createElement('style');
    style.textContent = `
    .pn-modal {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .pn-manual-modal-content {
      background-color: white;
      padding: 20px;
      border-radius: 5px;
      position: relative;
      max-width: 500px;
      width: 90%;
    }
    #pn-modal-close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      font-size: 20px;
    }
    .pn-mixed-cart-heading {
      font-weight: bold;
      margin-bottom: 10px;
    }
  `;
    document.head.appendChild(style);

    function checkCartAndShowPopup() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                checkForMixedCart(cart).then(hasMixedCart => {
                    if (hasMixedCart) {
                        console.log("Mixed cart detected! Showing warning...");
                        showPreorderWarning();
                    } else {
                        console.log("Cart is not mixed or is empty.");
                    }
                });
            })
            .catch(error => console.error('Error checking cart for mixed items:', error));
    }

    function setupAddToCartListeners() {
        const addToCartSelectors = [
            'button[name="add"]',
            'button.add-to-cart',
            'button.product-form--add-to-cart',
            'button.product-form__add-button',
            'button.ProductForm__AddToCart',        // Some themes
            'button[data-action="add-to-cart"]',
            'input[name="add"]',
            'input.add-to-cart'
        ];

        const addToCartButtons = document.querySelectorAll(addToCartSelectors.join(', '));

        addToCartButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                setTimeout(checkCartAndShowPopup, 100);
            });
        });
    }

    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
        return originalFetch.apply(this, arguments).then(function(response) {
            const urlString = url.toString();
            if (urlString.includes('/cart/add') || urlString.includes('/cart/update')) {
                setTimeout(checkCartAndShowPopup, 500);
            }
            return response;
        });
    };
    if (window.jQuery) {
        const originalAjax = jQuery.ajax;
        jQuery.ajax = function() {
            const xhr = originalAjax.apply(this, arguments);
            const url = arguments[0].url || '';
            if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update'))) {
                xhr.done(function() {
                    setTimeout(checkCartAndShowPopup, 500);
                });
            }
            return xhr;
        };
    }
});